import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Putting in an offer</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    {
                      url: '/putting-in-an-offer',
                      name: 'Putting in and offer',
                    },
                  ]}
                />
                <h2 className="lead text-center">Putting in an offer</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <h4>What an offer entails</h4>
                    <hr />
                    <p>
                      There are three main ways to buy a house in New Zealand –{' '}
                      <a href="/ways-to-purchase/negotiation">offer or negotiation</a>, &nbsp;
                      <a href="/ways-to-purchase/tender">tender</a>, and&nbsp;
                      <a href="/ways-to-purchase/auction">auction</a>.
                    </p>
                    <div className="paper paper-black" style={{ marginBottom: '30px' }}>
                      <p>So if you’re making a purchase, you’ll need to:</p>

                      <ul>
                        <li>Involve a lawyer</li>
                        <li>
                          Perform checks and reports to ensure that the property is in good condition – and that you’re
                          able to buy it
                        </li>
                        <li>Decide on the conditions of your offer</li>
                        <li>Decide on the amount to offer</li>
                        <li>Submit your offer</li>
                      </ul>
                    </div>
                    <br />
                    <p>
                      Offers are almost always made with a standardised Sale and Purchase Agreement that the selling
                      agent will provide to you
                    </p>
                    <br />
                    <div className="paper paper-black" style={{ marginBottom: '30px' }}>
                      <p>Key things to know about sale and purchase agreements:</p>
                      <ul>
                        <li>
                          A sale and purchase agreement is a legally binding contract between you and the other party
                          involved in buying or selling a property.{' '}
                        </li>
                        <li>You must sign a written sale and purchase agreement to buy or sell a property. </li>
                        <li>You need to read and understand the sale and purchase agreement before you sign it. </li>
                        <li>
                          You should always get legal advice before you sign the agreement and throughout the buying and
                          selling process.{' '}
                        </li>
                        <li>You can negotiate the conditions in a sale and purchase agreement.</li>
                        <li>A sale and purchase agreement becomes unconditional once all the conditions are met. </li>
                        <li>The real estate agent is working for the vendor but must treat the buyer fairly.</li>
                        <li>
                          If your agent or anyone related to them wants to buy your property, they must get your written
                          consent to do this. They must also give you an independent registered valuation of your
                          property
                        </li>
                      </ul>
                      <p>
                        The REA has an{' '}
                        <a href="https://www.rea.govt.nz/assets/Uploads/Resources/Guides/Sale-and-purchase-agreement-guide.pdf">
                          awesome pamphlet
                        </a>{' '}
                        on this that's worth a read{' '}
                      </p>
                    </div>
                    <h4>What do you need to do before making an offer</h4>
                    <hr />
                    <p>There are a few things you will need to do before putting in an offer</p>
                    <ol>
                      <li>Check the house is worth buying</li>
                      <p>
                        You’ll need to check the condition of a property before you commit to buying it. If you’re
                        buying by offer and negotiation, you can make these checks and reports conditions of your offer,
                        and do them while you’re negotiating. If you’re buying at auction or tender, you’ll want to have
                        all of them done beforehand.
                      </p>
                      <li>Ensure that you have access to the finances required</li>
                      <p>
                        This could be conditional/unconditional approval from a bank if you don’t have the amount
                        needed. You will also need to have access to the amount needed for the deposit. This is usually
                        10% of the purchase price, but this can be negotiated and updated in the purchase agreement.
                        Most agreements specify a cheque to be submitted with the offer, but we found all agents are
                        happy with the promise of a bank transfer on the event that you have the winning offer. This
                        saves a ton of hassle getting the cheque, submitting it, and then retrieving/cancelling it if
                        you don’t succeed.
                      </p>
                      <li>
                        {' '}
                        If you’re buying by offer or negotiation, you can set conditions before the actual sale takes
                        place
                      </li>
                      <p>
                        You can set as many conditions as you like, but more conditions can make it a less appealing
                        offer for the vendor. If the conditions are met in the time you specify, your offer goes
                        unconditional – which means you’re legally bound to buy the house. If the conditions aren’t met
                        – for example, if you’d listed a ‘satisfactory LIM report’ as a condition, and the LIM comes
                        back showing problems with the property – you can withdraw your offer with no repercussions.
                      </p>
                    </ol>
                    <p>
                      Make sure you allow yourself sufficient time to enable you to undertake all the required due
                      diligence items you have conditioned for – ie obtaining an offer of finance from your lender,
                      completion of a Registered Valuation, Building Report and review of the LIM report. If you have
                      tight timeframes this can become a stressful time.
                    </p>
                    <div className="paper paper-black" style={{ marginBottom: '30px' }}>
                      <p>Conditions can be just about anything you specify, but the most common ones are:</p>

                      <ul>
                        <li>Finance satisfactory to you</li>
                        <p>
                          This gives you time to arrange your home loan with the bank. Make sure you specify that it
                          must be ‘satisfactory to you’ – otherwise if you have a loan approved but the interest rate is
                          higher than you can handle, the vendor could force you to accept it.
                        </p>
                        <li>Valuation satisfactory to you</li>
                        <p>
                          This gives you time to get a registered valuer to tell you the market price of the property –
                          if the valuation doesn’t meet your expectations, you can withdraw your offer.
                        </p>
                        <li>Building inspection satisfactory to you</li>
                        <p>
                          This gives you time to get a licensed building surveyor to inspect the property to check for
                          any issues. Ask them to give you an idea of what it might cost to fix anything they find. If
                          the builder finds any problems, you may also want to get a report from an engineer.
                        </p>
                        <li>Subject to due diligence</li>
                        <p>
                          This can mean almost anything – it’s usually used if you want to make additions or
                          improvements to the house, and you need time to check with the authorities that you’ll be
                          allowed to do the work. You can also include conditions that require the vendor to do
                          something to the property by a certain date, like paint the house or repair something that’s
                          broken. These conditions don’t usually prevent the sale taking place, but they do allow you to
                          delay settlement until they’re met – or claim damages if they’re not.
                        </p>
                      </ul>
                    </div>
                    <h4>Should I make an offer?</h4>
                    <hr />
                    <p>
                      If all of your checks come back satisfactorily, you have the required finances, and (this is the
                      big one) you still like the house after finding out about its dirty laundry, then it’s time to put
                      in the offer.
                    </p>
                    <a href="https://www.kiwibank.co.nz/personal-banking/home-loans/getting-a-home-loan/first-home-buyers/making-an-offer/#more-checks-and-reports">
                      Checklist for making an offer
                    </a>
                    <h4>How to make the offer</h4>
                    <hr />
                    <p>Wooo, time to put that offer in!</p>
                    <p>
                      The first step is to give your lawyer the Sale and Purchase Agreement. They will check it for any
                      hidden gotchas, and fill in some of the details for you. However, you can skip this step if you
                      are confident in your contract reading/writing abilities{' '}
                    </p>
                    <p>
                      The second step is to fill in the Sale and Purchase Agreement, add your conditions, and then add
                      the all important $ number (hopefully you have some idea of what you want to offer).
                    </p>
                    <p>
                      Something you can do to make your offer stand out is to attach a personal letter to the offer when
                      you submit it. Add things that tell the vendor a bit about yourself, and why you like the house.
                      It only takes a second, and{' '}
                    </p>
                    <p>
                      Something you can do to make your offer stand out is to attach a personal letter to the offer when
                      you submit it. Add things that tell the vendor a bit about yourself, and why you like the house.
                      It only takes a second, and might be the thing that pushes your offer to the top.
                    </p>
                    <p>Finally, email, send, or drop off the agreement to the agent</p>
                    <div className="paper paper-black" style={{ marginBottom: '30px' }}>
                      <p>Tips for making an offer:</p>

                      <ul>
                        <li>Offer $10,000 or $15,000 below the maximum you would be willing to pay.</li>
                        <li>
                          Offer an uneven number such as $305,150 – it looks as if you are putting every last cent in.
                          You could also write down and cross out some lower figures, such as $300,000 and $301,000
                        </li>
                        <li>
                          If you can't get to the amount the vendor wants, give them something else – choice of
                          settlement date, fewer conditions.
                        </li>
                        <li>Don't let pride get in the way of buying your dream home.</li>
                        <li>
                          If you are in a multiple offer situation, you need to put your best price forward first time.
                          This is a common one in this market, and so you may not get a second shot. Which negates a few
                          of the above tips
                        </li>
                      </ul>
                    </div>
                    <h4>What to do once the offer is made</h4>
                    <hr />
                    <p>
                      Once your offer is made, there's nothing else left for you to do but wait. Hopefully you will find
                      out the result within a day or so. If you are successful, then get onto sorting out you conditions
                      nice and quick as the settlement day will roll around faster than you think. If you are
                      unsuccessful, then try not to get to disappointed (this is difficult) , and keep on hunting; we
                      submitted seven offers before we were successful, and each house was better than the last. It
                      shows the old adage of “you will end up with the best house for you” :)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PuttingInAnOffer.jsx